import cl from 'clsx';

import baseClasses from './CssSpinner.module.scss';

export type CssSpinnerProps = {
  classes: {
    root?: string;
    circle: string;
    /*
    border-width: 
    width: 
    height: 
    border-color:
    */
  };
};
export const CssSpinner = ({ classes }: CssSpinnerProps) => {
  return (
    <div className={classes.root}>
      <div className={cl(baseClasses.circle, classes.circle)} />
    </div>
  );
};
